import styled from "@emotion/styled";
import { FormProvider, useForm } from "react-hook-form";

import { zodResolver } from "@hookform/resolvers/zod";
import { aiProductSchema } from "@libs/zod/zodVaildation";
import Resize from "./_components/Resize";

const Capture = () => {
  const methods = useForm({
    resolver: zodResolver(aiProductSchema()),

    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      image: null,
      category: null,
      categoryDepth1: null,
      categoryDepth2: null,
      categoryDepth3: null,
      categoryDepth4: null,
      color: null,
      pattern: null,
    },
  });

  return (
    <FormProvider {...methods}>
      <Container>
        <Resize />
      </Container>
    </FormProvider>
  );
};

export default Capture;

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
});
